import styled, { css } from 'styled-components';


interface LIProps{
    isActive?: boolean;
}

export const Container = styled.div`

width: 100%;
height: 60px;

display: flex;
align-items: center;
justify-content: space-between;

background-color: #fff9eb;


margin-bottom: 50px;


`
export const Retangule = styled.div`

width: 272px;

border-right: 1px solid #e5ebec;


display:flex;
justify-content: center;
align-items: center;



`


export const Logo = styled.img`



`
export const LI = styled.li<LIProps>`
        margin: 20px 20px 0 0;

        display: flex;

        cursor: pointer;

        &:hover{
            opacity:0.5;
        }

        ${props=>
        props.isActive &&(
            css`
            color:red;
            `
        )}


`

export const Menu = styled.div`

    height: 60px;
    font-size: 24px;
    color: #545454;

    display: flex;
    align-items: center;
    justify-content: center;

ul{
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: center;

    a{
        text-decoration: none;
        color: #545454;
    }


    #point{
            content: '';
            background-color: #f85d00;
            width: 10px;
            height: 10px;
            border-radius:50%;
        }
    }


`




export const BoxRight = styled.div`

    display: flex;
    align-items: center;

`


export const Welcome = styled.div`

margin-right: 30px;

cursor: default;

font-weight:bold;

`;


export const Exit = styled.div`

  
    &:hover{     
        opacity: 0.5;
        cursor: pointer;
        }

    border-left: 1px solid #e5ebec;



    padding: 0 20px;

    display: flex;
    align-items: center;



    #IconFacebook{
    color: red;
    margin-right: 10px;

} 

`;
